import { CustomReport, DefaultSelectedFilters, Record, ReportSummary, StaticFilters } from '../../reports/types';
import { deleteRequest, getRequest, getWithParamsRequest, postRequest, putRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export interface ReportsParamsAPI {
  startDate?: string;
  endDate?: string;
  filterDate?: string;
  statuses?: string[];
  riders?: string[];
  categories?: string[];
  tags?: string[];
  groupBy?: string;
  default?: boolean;
  favorite?: boolean;
}

export async function getReports(
  queryParams: ReportsParamsAPI,
  signal?: AbortSignal
): Promise<ApiResponse<{ aggregates: ReportSummary; records: Record[] }>> {
  return getWithParamsRequest('reports', queryParams, signal);
}

export async function postReports(
  params: ReportsParamsAPI,
  signal?: AbortSignal
): Promise<ApiResponse<{ info: string }>> {
  return postRequest('reports', params, signal);
}

export async function getDownload(uuid: string, signal?: AbortSignal): Promise<ApiResponse<string>> {
  return getWithParamsRequest(`reports/${uuid}/download`, { format: 'csv' }, signal);
}

export async function getCustomReports(signal?: AbortSignal): Promise<ApiResponse<CustomReport[]>> {
  return getRequest('report_filters', signal);
}

export async function createCustomReport(params: ReportsParamsAPI): Promise<ApiResponse<CustomReport>> {
  return postRequest('report_filters', params);
}

export async function updateCustomReport(uuid: string, params: ReportsParamsAPI): Promise<ApiResponse<CustomReport>> {
  return putRequest(`report_filters/${uuid}`, params);
}

export async function deleteCustomReport(uuid: string): Promise<ApiResponse<{ message: string }>> {
  return deleteRequest(`report_filters/${uuid}`);
}

export async function getDefaultOptions(
  signal?: AbortSignal
): Promise<ApiResponse<{ staticFilters: StaticFilters; defaultSelectedFilters: DefaultSelectedFilters }>> {
  return getRequest('reports/default_options', signal);
}
